import { useEffect, useRef } from 'react';
/** Keeps a message container scrolled to the bottom when `scrollKey` changes. */
export function useChatScrollToBottom(scrollKey) {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (el)
            el.scrollTop = el.scrollHeight;
    }, [scrollKey]);
    return ref;
}
